/* eslint-disable react/prop-types */
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

import Constants from 'utils/constants';
import Tooltip from 'components/tooltip';
import OverlayTrigger from 'components/overlay_trigger';
import Emoji from 'components/emoji/emoji';

interface PostEmojiProps {
    name: string;
    imageUrl: string;
    overlayPlacement?: string;
}

const PostEmoji: React.VoidFunctionComponent<PostEmojiProps> = (props) => {
    const {imageUrl, name, overlayPlacement = 'top'} = props;
    const emojiText = ':' + name + ':';

    const style = React.useMemo(() => ({backgroundImage: 'url(' + imageUrl + ')'}), [imageUrl]);

    if (!imageUrl) {
        return <span>{emojiText}</span>;
    }

    return (
        <OverlayTrigger
            delayShow={Constants.OVERLAY_TIME_DELAY}
            placement={overlayPlacement}
            shouldUpdatePosition={true}
            overlay={
                <Tooltip id={`emoticon-preview-${emojiText}`}>
                    <Emoji name={name} preview={true} />
                    <div>{emojiText}</div>
                </Tooltip>
            }
        >
            <span
                role='img'
                aria-label={emojiText}
                className='emoticon'
                style={style}
            >
                {emojiText}
            </span>
        </OverlayTrigger>
    );
};

export default PostEmoji;
